<template>
    <div>
        <b-modal
            id="score-breakdown-popup"
            ref="modal"
            size="sm"
            modal-class="hide-footer"
            hide-footer
            no-close-on-backdrop
            no-close-on-esc
            :hide-header-close="loading"
            @hidden="hideModal"
        >
            <div slot="modal-header" class="w-100 archive-popup">
                <h5 class="modal-title">{{ title }}</h5>
            </div>
            <div class="export-process custom-model-form">
                <p v-if="data">
                    <template v-if="isAdverseMediaHit">
                        <ul>
                            <li class="leftPoint">
                                <strong> Smart Search Points:</strong> {{ hitScore }}  
                            </li>
                            <li class="leftPoint">
                                <strong> Keywords:</strong> {{ keywords.length > 0 ? Object.keys(JSON.parse(keywords)).join(", ") : "N/A"  }}  
                            </li>
                        </ul>
                    </template>
                    <template v-else>
                        <ul>
                            <li v-for="(value, key) in data" v-bind:key="key" class="leftPoint" >
                                <strong> {{ key }} :</strong> 
                                <template v-if=" typeof value== 'object' ">
                                    <ul>
                                        <li v-for="(val, k) in value" :key="k">
                                            <strong> {{ camelCaseToWords(k) }} :</strong>  {{val}}
                                        </li>
                                    </ul>
                                </template>
                                <template v-else>
                                    {{ value }}
                                </template>
                            </li>
                        </ul>
                    </template>
                </p>
            </div>
            <div class="col-md-12 action-buttons">
                <button
                    class="btn btn-primary"
                    type="submit"
                    @click="hideModal"
                >
                    <span class="btn-text">CLOSE</span>
                </button>
                
            </div>
        </b-modal>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import excelIcon from '@/components/icons/ExcelIcon.vue'
import request from '@/utils/request'

export default {
    components: {
        excelIcon,
    },
    props: {
        title: {
            type: String,
            default: "Score Breakdown",
            // required: true,
        },
        data: {
            type: Object,
            // required: true,
            default: {},
        },
        keywords: {
            type: Array,
            default: [],
        },
        isAdverseMediaHit: {
            type: Boolean,
            default: false,
        },
        hitScore: {
            type: Number,
            default: 0
        }
    },
    computed: {
        ...mapGetters(['loading']),
    },
    methods: {
        hideModal() {
            this.$refs['modal'].hide()
            this.$emit('close');
        },
        camelCaseToWords(str) {
            if(str=='') return '';

            var words = str.replace(/([A-Z])/g, ' $1');
            
            words = words.trim();
            // Capitalize the first letter of each word
            words = words.replace(/^./, function(match) {
            return match.toUpperCase();
            });
            
            return words;
        }

    
    },
}
</script>

<style scoped>
.leftPoint{
    font-size: 15px;
    text-align: left;
}
</style>
